import React from 'react';
import { Modal } from 'antd';

export default function showRegisterInstructionsModal(msg) {
  const linkUrl = msg('modal.link');

  Modal.info({
    title: msg('modal.title', {
      link: chunks => (
        <a href={linkUrl} target="_blank" rel="noopener noreferrer">
          {chunks}
        </a>
      ),
    }),
    width: 720,
    icon: null,
    okButtonProps: { style: { display: 'none' } },
    wrapClassName: 'app-modal',
  });
}
